export default "__VITE_ASSET__n7yEytHw__"